/**
 * Per-tab memory of the last view (filters, search, sort, page, smart list) a
 * user had on each CRM list page.
 *
 * The pages already encode their whole view in the URL query string, so the
 * "snapshot" is just that string. Arriving at a bare list URL — which is what
 * every sidebar link produces — replays the saved one.
 *
 * sessionStorage is deliberate: the view is remembered for as long as the tab
 * is open and a brand-new tab starts clean.
 */

const KEY_PREFIX = 'crmViewSession:';

export const CRM_VIEW_KEYS = {
  dashboard: 'dashboard',
  myDeals: 'myDeals',
};

/**
 * @returns {string|null} The saved query string (including the leading '?'),
 *   or null when nothing is saved. An empty string means the user deliberately
 *   saved a clean view, so it reads back as null and triggers no restore.
 */
export function readViewSearch(viewKey) {
  try {
    return sessionStorage.getItem(KEY_PREFIX + viewKey) || null;
  } catch (e) {
    return null;
  }
}

export function writeViewSearch(viewKey, search) {
  try {
    sessionStorage.setItem(KEY_PREFIX + viewKey, search || '');
  } catch (e) {
    // Storage disabled (Safari private mode) or full: fall back to no memory.
  }
}

export function clearAllViewSessions() {
  try {
    Object.values(CRM_VIEW_KEYS).forEach((key) => {
      sessionStorage.removeItem(KEY_PREFIX + key);
    });
  } catch (e) {
    // Nothing to clean up if storage is unavailable.
  }
}
